export default "__VITE_ASSET__f54d3e74__"